"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuConceptDetailsPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var console_1 = require("../../../../reducers/slices/console");
var step_indicator_1 = require("./menu_concepts/step_indicator");
var basic_info_1 = require("./menu_concepts/basic_info");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var routes_1 = require("../../../../constants/routes");
var product_selection_1 = require("./menu_concepts/product_selection");
var product_configuration_1 = __importDefault(require("./menu_concepts/product_configuration"));
var catalog_set_review_1 = require("./menu_concepts/catalog_set_review");
var MenuConceptDetailsPage = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Menu Concept Details"));
    });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-row" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { iconColor: "text-black", label: "Back To Catalog Set Management", size: "xsmall", startIcon: pro_solid_svg_icons_1.faChevronLeft, backgroundColor: "bg-transparent", textColor: "text-black", onClick: function () {
                        navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.MENU_CONCEPT_LIST_ROUTE));
                    } }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "" }, { children: (0, jsx_runtime_1.jsx)(step_indicator_1.StepIndicator, { title: "Catalog Set Creation", allowStepClick: false, steps: [
                        {
                            label: "Basic Information",
                            content: function (_a) {
                                var goToStep = _a.goToStep;
                                return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "mt-6" }, { children: (0, jsx_runtime_1.jsx)(basic_info_1.BasicInfo, __assign({}, { goToStep: goToStep, step: 1 })) })));
                            },
                        },
                        {
                            label: "Product Selection",
                            content: function (_a) {
                                var goToStep = _a.goToStep;
                                return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "mt-6" }, { children: (0, jsx_runtime_1.jsx)(product_selection_1.ProductSelection, __assign({}, { goToStep: goToStep, step: 2 })) })));
                            },
                        },
                        {
                            label: "Product Configuration",
                            content: function (_a) {
                                var goToStep = _a.goToStep;
                                return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "mt-6" }, { children: (0, jsx_runtime_1.jsx)(product_configuration_1.default, __assign({}, { goToStep: goToStep, step: 3 })) })));
                            },
                        },
                        {
                            label: "Catalog Set Review",
                            content: function (_a) {
                                var goToStep = _a.goToStep;
                                return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "mt-6" }, { children: (0, jsx_runtime_1.jsx)(catalog_set_review_1.CatalogSetReview, __assign({}, { goToStep: goToStep, step: 4 })) })));
                            },
                        },
                    ] }) }))] })));
};
exports.MenuConceptDetailsPage = MenuConceptDetailsPage;
